import { RuleBuilder } from '../search'

// Global Text Search wrapper around the shared RuleBuilder. Adds the Save button
// so the user's rule set can be persisted as a TextSearch entity.
function GlobalTextSearchRuleBuilder({ draft, onChange, onRun, onSave, running, saving, dirty }) {
  const saveButton = (
    <button
      type="button"
      className="ts-btn ts-btn-ghost"
      onClick={onSave}
      disabled={saving || !dirty}
    >
      {saving ? 'Saving…' : dirty ? 'Save' : 'Saved'}
    </button>
  )

  return <RuleBuilder draft={draft} onChange={onChange} onRun={onRun} running={running} extraActions={saveButton} />
}

export default GlobalTextSearchRuleBuilder
